import React from 'react';
import { EmptyState } from '@/components/EmptyState';
import { Users } from 'lucide-react';

export const TalentMarketplace: React.FC = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground">Talent Marketplace</h1>
        <p className="text-muted-foreground">Connect with top talents for partnerships and collaborations</p>
      </div>
      
      <EmptyState
        title="Coming Soon"
        description="The talent marketplace will be available once we have talents registered on the platform."
        icon={<Users className="w-8 h-8 text-muted-foreground" />}
      />
    </div>
  );
};

export default TalentMarketplace;